import { render } from "./MainListPurchaseOrder.vue?vue&type=template&id=04595e8a&scoped=true"
import script from "./MainListPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./MainListPurchaseOrder.vue?vue&type=script&lang=js"

import "./MainListPurchaseOrder.vue?vue&type=style&index=0&id=04595e8a&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04595e8a"]])

export default __exports__